<template>
  <div class="notification-list">
    <template v-if="notifications.length > 0">
      <notification-item
        v-for="notification in notifications"
        :key="notification.id"
        :notification="notification"
        @rent-action="onRentAction"
      >
      </notification-item>
    </template>
    <template v-else>
      <b-row class="py-5 text-center">
        <b-col
          ><p>
            {{
              loading
                ? 'Please wait while we fetch your notifications...'
                : 'You have no notifications currently...'
            }}
          </p></b-col
        >
      </b-row>
    </template>
  </div>
</template>
<script>
/**
 * ==================================================================================
 * Notification List
 * ==================================================================================
 **/

import { mapState, mapMutations, mapActions } from 'vuex'
import NotificationItem from '@/components/cards/NotificationItem'
import debounce from 'lodash/debounce'

export default {
  components: {
    NotificationItem
  },
  computed: {
    ...mapState({
      notifications: state => state.notification.list,
      notificationsMeta: state => state.notification.listMeta
    })
  },
  data: function() {
    return {
      loading: false
    }
  },
  methods: {
    ...mapActions({
      getNotifications: 'notification/getNotifications',
      markAsRead: 'notification/markAsRead',
      addAlert: 'alert/addAlert'
    }),
    ...mapMutations({
      addNotification: 'notification/addNotification',
      clearNotifications: 'notification/clearNotificationList',
      clearNotification: 'notification/clearNotificationListItemDetails'
    }),
    async fetchNotifications(page = 1) {
      if (this.loading) return
      this.loading = true
      this.addAlert({
        label: 'Loading notifications...'
      })

      let params = {
        page: page,
        limit: 4,
        mine: true
      }

      await this.getNotifications(params)
      this.loading = false
      this.$root.$emit('alert-message-remove')
    },

    async onRentAction(data) {
      this.clearNotification(data.oldNotification.id)
      this.addNotification(data.newNotification)
      this.scrollToTop()

      await this.markAsRead({ notification_ids: [data.newNotification.id] })
    },

    handleScroll(e) {
      if (!this.notificationsMeta) return
      const docEl = document.documentElement
      if (docEl.scrollTop + window.innerHeight === docEl.scrollHeight) {
        this.loadMore()
      }
    },

    loadMore() {
      if (
        this.notificationsMeta.current_page < this.notificationsMeta.last_page
      ) {
        this.fetchNotifications(this.notificationsMeta.current_page + 1)
      }
    }
  },
  async created() {
    this.clearNotifications()
    this.fetchNotifications()

    this.handleDebouncedScroll = debounce(this.handleScroll, 100)
    window.addEventListener('scroll', this.handleDebouncedScroll)
  },

  destroyed() {
    window.removeEventListener('scroll', this.handleDebouncedScroll)
  }
}
</script>
<style lang="scss" scoped>
.notification-list {
  .notification-item {
    margin: 0 auto 40px auto;
  }
}
</style>
